// extracted by mini-css-extract-plugin
export default {"root":"split_mode_overlay-module___root___edf58f3d"};